import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import NovoPedido from "@/pages/NovoPedido";
import AtendimentoDetail from "@/pages/AtendimentoDetail";
import Clientes from "@/pages/Clientes";
import Veiculos from "@/pages/Veiculos";
import Artigos from "@/pages/Artigos";
import Fornecedores from "@/pages/Fornecedores";
import Encomendas from "@/pages/Encomendas";
import PorEncomendar from "@/pages/PorEncomendar";
import Logistica from "@/pages/Logistica";
import Utilizadores from "@/pages/Utilizadores";
import Historicos from "@/pages/Historicos";
import Duplicados from "@/pages/Duplicados";
import NotasCredito from "@/pages/NotasCredito";
import EntidadeHistorico from "@/pages/EntidadeHistorico";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-slate-400">A carregar…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return <Layout>{children}</Layout>;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<Protected><Dashboard /></Protected>} />
            <Route path="/pedido/novo" element={<Protected><NovoPedido /></Protected>} />
            <Route path="/pedido/:id" element={<Protected><AtendimentoDetail /></Protected>} />
            <Route path="/encomendas" element={<Protected><Encomendas /></Protected>} />
            <Route path="/por-encomendar" element={<Protected><PorEncomendar /></Protected>} />
            <Route path="/logistica" element={<Protected><Logistica /></Protected>} />
            <Route path="/clientes" element={<Protected><Clientes /></Protected>} />
            <Route path="/veiculos" element={<Protected><Veiculos /></Protected>} />
            <Route path="/artigos" element={<Protected><Artigos /></Protected>} />
            <Route path="/fornecedores" element={<Protected><Fornecedores /></Protected>} />
            <Route path="/utilizadores" element={<Protected><Utilizadores /></Protected>} />
            <Route path="/historicos" element={<Protected><Historicos /></Protected>} />
            <Route path="/duplicados" element={<Protected><Duplicados /></Protected>} />
            <Route path="/notas-credito" element={<Protected><NotasCredito /></Protected>} />
            <Route path="/registo/:tipo/:id" element={<Protected><EntidadeHistorico /></Protected>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
